import React, { memo } from 'react'
import sponsorStyles from '../../styles/tracker-modules/sponsor.module.less'

const Sponsor = ({ img, link, text, kicker, textUrl }) => {
  // get paid
  const alt = "The logo of this page's sponsor"

  return (
    <div className={sponsorStyles.wrapper}>
      <div>
        <p className={sponsorStyles.hed}>Supported by</p>
        <a href={link} target="_blank" rel="noreferrer">
          <img alt={alt} src={img} />
        </a>
      </div>
      {textUrl && text && (
        <div className={sponsorStyles.secondary}>
          {kicker && <p className={sponsorStyles.hed}>{kicker}</p>}
          <a href={textUrl} target="_blank" rel="noreferrer">
            <p className={sponsorStyles.text}>{text}</p>
          </a>
        </div>
      )}
    </div>
  )
}

export default memo(Sponsor)
